import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RequestCategotyWithTypesModel } from "../../../../shared/models/request/request-categoty-with-types-model";
import { UserEngineerDto } from "../../../../shared/models/User/user-engineer.dto";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { KeyValueObject } from "../../../../shared/models/core/KeyValueObject";
import { RequestCategoryEnum } from "../../../../shared/enums/request-category.enum";
import { PlanningService } from "../../../../shared/services/planning.service";
import { NotificationService } from "../../../../core/services/notification.service";
import { NotificationType } from "../../../../core/services/notification-type";
import { AlgoritmType } from "../../../../constants/planning.constants";
import { SecurityService } from "../../../../core/services/security.service";

interface IDay {
    value: Date;
    number: number;
    name: string;
    isDayOff: boolean;
}

@Component({
    selector: 'planning-map-menu',
    templateUrl: './planning-map-menu.component.html',
    styleUrls: [
        './planning-map-menu.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
        '../../../../../vendor/libs/ngx-contextmenu/ngx-contextmenu.scss',
    ]
})
export class PlanningMapMenuComponent implements OnInit, AfterContentChecked {

    public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    @Input() requestCategories: RequestCategotyWithTypesModel[] = [];
    @Input() serviceCenters: KeyValueObject[] = [];
    @Input() userEngineers: UserEngineerDto[] = [];
    @Input() planningLoading: boolean = false;
    @Input() planningMode: boolean = false;
    @Input() confirmPlanningLoading: boolean = false;
    @Input() confirmPlanningDisabled: boolean = false;

    @Output() changeDay: EventEmitter<Date> = new EventEmitter();
    @Output() changeEngineers: EventEmitter<number[]> = new EventEmitter();
    @Output() changeRequestCategories: EventEmitter<number[]> = new EventEmitter();
    @Output() changeServiceCenter: EventEmitter<number> = new EventEmitter();
    @Output() startPlanningEvent: EventEmitter<any> = new EventEmitter();
    @Output() cancelPlanningModeEvent: EventEmitter<any> = new EventEmitter();
    @Output() confirmPlanningEvent: EventEmitter<any> = new EventEmitter();
    @Output() changeShowRoutes: EventEmitter<boolean> = new EventEmitter();

    showRoutes: boolean = false;

    targetDate = new Date();

    constructor(
        private changeDetector: ChangeDetectorRef,
        private planningService: PlanningService,
        private notificationService: NotificationService,
        private securityService: SecurityService
    ) { }

    ngAfterContentChecked(): void {
        this.initUserEngineers();
    }

    defaultDaysRange = 7;
    defaultDayIndex = 1;
    defaultEngineerColor = 'black';
    defaultNotSelectedEngineer: UserEngineerDto = {
        userId: 0, fullName: 'Не назначен', displayName: 'Не назначен', color: '#465bff', workTimeInMinutes: null, integraCode: null
    };

    days: IDay[] = [];
    selectedRequestCategoryIds: number[] = [];
    savedRequestCategoryIds: number[] = [];
    selectedDayIndex: number;
    selectedUserEngineerIds: number[] = [];
    selectedServiceCenterId: number;
    autoAssignmentDisabled: boolean = true;

    ngOnInit(): void {
        this.planningService.getAlgoritmType().subscribe(res => {
            if (res) {
                this.autoAssignmentDisabled = res !== AlgoritmType.yandex;
            }
        });
        this.initUserEngineers();
        this.initDays(this.targetDate);
        this.selectDay(this.defaultDayIndex);
    }

    private initUserEngineers() {
        if (!this.userEngineers.some(x => x.userId == 0)) {
            this.userEngineers.unshift(this.defaultNotSelectedEngineer);
        }
    }

    onShowRoutesChange(value: boolean): void {
        if (this.changeShowRoutes) {
            this.changeShowRoutes.emit(value);
        }
    }

    get canViewEmployeeRoutes(): boolean {
        return this.securityService.canViewEmployeeRoutes() || this.securityService.isAdmin();
    }

    private initDays(startDate: Date) {
        const dayNames = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
        const startDay = new Date(startDate);
        this.days = [];

        for (let i = 0; i < this.defaultDaysRange; i++) {
            const date = new Date(startDay);
            date.setDate(startDay.getDate() + i);

            const dayOfWeek = date.getDay();

            this.days.push({
                value: date,
                number: date.getDate(),
                name: dayNames[dayOfWeek],
                isDayOff: dayOfWeek === 0 || dayOfWeek === 6
            });
        }
    }

    selectDay(dayIndex: number) {
        this.selectedDayIndex = dayIndex;
        this.changeDay.emit(this.days[dayIndex].value);
    }

    startPlanning() {
        if (!this.selectedServiceCenterId) {
            this.notificationService.error({
                title: 'Ошибка',
                message: 'Для запуска автоназначения выберите нужный филиал',
                notificationType: NotificationType.SweetAlert
            });
        }
        /*else if (this.selectedRequestCategoryIds.length !== 1) {
            this.notificationService.error({
                title: 'Ошибка',
                message: 'Для запуска необходимо выбрать одну категорию',
                notificationType: NotificationType.SweetAlert
            });
        } */
        else {
            this.startPlanningEvent.emit();
        }
    }

    cancelPlanningMode() {
        this.cancelPlanningModeEvent.emit()
    }

    confirmPlanning() {
        this.confirmPlanningEvent.emit();
    }

    selectRequestCategories(requestCategoryIds: number[] = []) {
        // const flowingSystem = <number>RequestCategoryEnum.flowingSystems;
        // const osmoSystem = <number>RequestCategoryEnum.householdOsmo;

        // if (requestCategoryIds.includes(flowingSystem) && !this.savedRequestCategoryIds.includes(flowingSystem)) {
        //     requestCategoryIds.push(osmoSystem);
        // }
        // else if (requestCategoryIds.includes(osmoSystem) && !this.savedRequestCategoryIds.includes(osmoSystem)) {
        //     requestCategoryIds.push(flowingSystem);
        // }
        // else if (this.savedRequestCategoryIds.includes(flowingSystem) && !requestCategoryIds.includes(flowingSystem)) {
        //     requestCategoryIds = requestCategoryIds.filter(x => x != osmoSystem);
        // }
        // else if (this.savedRequestCategoryIds.includes(osmoSystem) && !requestCategoryIds.includes(osmoSystem)) {
        //     requestCategoryIds = requestCategoryIds.filter(x => x != flowingSystem);
        // }

        this.selectedRequestCategoryIds = requestCategoryIds;
        this.savedRequestCategoryIds = requestCategoryIds;
        this.changeRequestCategories.emit(requestCategoryIds);
    }

    selectServiceCenter(serviceCenterId: number) {
        this.changeServiceCenter.emit(serviceCenterId);
    }

    selectEngineer(userId: number) {
        if (this.isSelectedEngineer(userId)) {
            this.selectedUserEngineerIds = this.selectedUserEngineerIds.filter(x => x != userId);
        }
        else {
            this.selectedUserEngineerIds.push(userId);
        }

        this.changeEngineers.emit(this.selectedUserEngineerIds);
    }

    forceSetUserEngineer(userId: number) {
        this.selectedUserEngineerIds = [userId];
        this.changeDetector.detectChanges();
    }

    isSelectedEngineer(userId: number) {
        return this.selectedUserEngineerIds.some(x => x == userId);
    }

    getEngineerColor(engineer: UserEngineerDto): string {
        return engineer.color == null ? this.defaultEngineerColor : engineer.color;
    }

    getMonthName(dayIndex: number): string {
        const day = this.days[dayIndex];
        const s = new Intl.DateTimeFormat("ru-RU", { month: "long" }).format(day.value);
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    getYearYYYY(dayIndex: number): string {
        const day = this.days[dayIndex];
        return String(day.value.getFullYear());
    }

    moveToBackDay() {
        if (!this.isFirstDay) {
            this.selectDay(this.selectedDayIndex - 1);
        } else {
            this.targetDate = this.addDays(this.targetDate, this.selectedDayIndex - 1);
            this.initDays(this.targetDate);
            this.selectDay(0);
        }
    }

    moveToNextDay() {
        if (!this.isLastDay) {
            this.selectDay(this.selectedDayIndex + 1);
        } else {
            this.targetDate = this.addDays(this.targetDate, 1);
            this.initDays(this.targetDate);
            this.selectDay(this.days.length - 1);
        }
    }

    addDays(date: Date, days: number): Date {
        const d = new Date(date);        // копия, чтобы не мутировать исходную дату
        d.setDate(d.getDate() + days);
        return d;
    }

    isEmpty(value: string): boolean {
        return value == null || value.trim() == '';
    }

    isUserHasWorkTime(engineer: UserEngineerDto): boolean {
        return !!engineer.workTimeInMinutes;
    }

    getUserWorkTime(engineer: UserEngineerDto): string {
        const userWorkTime = engineer.workTimeInMinutes;
        const hours = Math.floor(userWorkTime / 60);
        const minutes = userWorkTime % 60;
        let result = `(${hours}ч.`;
        if (minutes !== 0) {
            result += ` ${minutes}мин.`;
        }
        return result += ')';
    }

    get isFirstDay() {
        return this.selectedDayIndex == 0;
    }

    get isLastDay() {
        return this.selectedDayIndex == this.days.length - 1;
    }
}